<!--Popup info box -->
<div class="popup-info" [ngClass]="{'fade': popupClosed}" [class.none]="removeElm">
  <i class="fa fa-check check-icon"></i>
  <a
    href="javascript:void(0)"
    class="close-icon"
    aria-label="clickable"
    (click)="closePopup()"
    id="cta-default-215"
    ><i class="fa fa-times"></i
  ></a>
  <p class="lead">{{message}}</p>
</div>
<!--Popup info box ends-->
